import { Attachment, FileGenerationStatus } from "../types/chat";
import { Download, Loader2 } from "lucide-react";
import { getFile } from "services/storage-service";
import { useConfig } from "hooks/use-config";
// import { useTheme } from "components/core/theme-provider";

export const DownloadAssistantFile = ({ file }: { file: Attachment }) => {
    const { configurationSettings } = useConfig();
    // const { theme } = useTheme();

    const downloadFile = async (fileId: string) => {
        const response = await getFile(fileId, configurationSettings, undefined);
        if (response.isSuccess && response.url) {
            const link = document.createElement('a');
            link.href = response.url;
            link.download = file.fileName;
            link.click();
        }
    }

    if (file.sender === 'assistant' && file.status && file.status === FileGenerationStatus.IN_PROGRESS) {
        return (
            <Loader2 className="h-4 w-4 animate-spin text-primary" />
        )
    }
    return (
        <button
            title="Download file"
            className={`text-gray-500 dark:text-gray-400 flex items-center justify-center h-8 w-8 p-1 rounded-full hover:bg-muted`}
            onClick={() => downloadFile(file.fileId)}
        >
            <Download className="h-4 w-4" />
        </button>
    )
};